import React from 'react';
import { OrderProduct } from './OrderTypes';

interface OrderSummarySidebarProps {
  selectedProduct: OrderProduct;
  options: Record<string, string | number>;
  quantity: number;
  orderPrice: number;
}

const OrderSummarySidebar: React.FC<OrderSummarySidebarProps> = ({ selectedProduct, options, quantity, orderPrice }) => {
  const computeArea = () => {
    const width = Number(options['width']) || 0;
    const height = Number(options['height']) || 0;
    return width * height;
  };

  return (
    <div className="sticky-summary-sidebar bg-white rounded-4 shadow-sm border border-light p-4" style={{
      position: 'sticky',
      top: '100px',
      borderRadius: '14px',
      border: '1px solid #eaeef5',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)',
      transition: 'all 0.3s ease',
    }}>
      <h4 className="fw-bold text-dark mb-4" style={{ fontSize: 'clamp(16px, 4vw, 18px)', letterSpacing: '-0.3px', paddingBottom: '16px', borderBottom: '2px solid #f0f0f0' }}>
        Order Summary
      </h4>

      <div className="summary-item mb-4 d-flex align-items-start gap-3 p-3 rounded-3" style={{ background: '#f8f9fb', transition: 'all 0.3s ease' }}>
        <div className="product-summary-thumb rounded-2" style={{
          width: '70px',
          height: '70px',
          overflow: 'hidden',
          background: '#f0f0f0',
          flexShrink: 0,
          border: '1px solid #eaeef5',
        }}>
          <img src={selectedProduct.img} alt={selectedProduct.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
        <div style={{ flex: 1 }}>
          <div className="fw-bold text-dark" style={{ fontSize: 'clamp(14px, 3vw, 15px)', marginBottom: '4px' }}>
            {selectedProduct.name}
          </div>
          <div className="text-muted" style={{ fontSize: '12px' }}>
            Base Price: <span className="text-primary fw-bold">₹{selectedProduct.basePrice}/unit</span>
          </div>
        </div>
      </div>

      <div className="mb-4">
        <h6 className="fw-bold text-dark mb-3" style={{ fontSize: 'clamp(12px, 2.5vw, 13px)', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#666' }}>
          Configurations:
        </h6>
        <ul className="list-unstyled mb-0" style={{ fontSize: '12px' }}>
          {Object.entries(options).map(([key, val]) => {
            const label = selectedProduct.options.find(o => o.name === key)?.label || key;
            const unit = selectedProduct.options.find(o => o.name === key)?.unit || '';
            return (
              <li key={key} className="mb-2 d-flex justify-content-between align-items-center p-2 rounded-2" style={{ background: '#fafbfe', fontSize: '12px' }}>
                <span style={{ color: '#666' }}>{label}:</span>
                <span className="fw-semibold text-dark" style={{ color: '#e91e8c' }}>{val}{unit}</span>
              </li>
            );
          })}
          <li className="mb-2 d-flex justify-content-between align-items-center p-2 rounded-2" style={{ background: '#fafbfe', fontSize: '12px' }}>
            <span style={{ color: '#666' }}>Quantity:</span>
            <span className="fw-semibold text-dark" style={{ color: '#e91e8c' }}>{quantity.toLocaleString()} units</span>
          </li>
          {selectedProduct.id === 'flex-banners' && (
            <li className="mb-0 d-flex justify-content-between align-items-center p-2 rounded-2" style={{ background: '#fafbfe', fontSize: '12px' }}>
              <span style={{ color: '#666' }}>Total Area:</span>
              <span className="fw-semibold text-dark" style={{ color: '#e91e8c' }}>{computeArea()} sq. ft.</span>
            </li>
          )}
        </ul>
      </div>

      <div style={{ height: '2px', background: 'linear-gradient(90deg, transparent, #eaeef5, transparent)', margin: '20px 0' }} />

      <div className="estimated-price-box p-4 rounded-3 mb-4 text-center" style={{
        background: 'linear-gradient(135deg, #fff5fb 0%, #fdf2f8 100%)',
        border: '1px solid #ffe6f0',
      }}>
        <span className="text-muted d-block fw-bold mb-2" style={{ fontSize: '11px', letterSpacing: '0.5px', textTransform: 'uppercase', color: '#999' }}>
          Estimated Total
        </span>
        <div className="fw-bold display-6" style={{
          fontSize: 'clamp(24px, 6vw, 32px)',
          background: 'linear-gradient(135deg, #e91e8c 0%, #3b5bdb 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          margin: '8px 0',
        }}>
          ₹{orderPrice.toLocaleString('en-IN')}
        </div>
        <span className="text-muted d-block mt-2" style={{ fontSize: '11px', color: '#999' }}>
          *Includes GST and basic materials
        </span>
      </div>

      <div className="d-flex flex-column gap-3" style={{ fontSize: '12px' }}>
        <div className="d-flex align-items-center gap-3 p-2 rounded-2" style={{ background: '#f8f9fb', transition: 'all 0.3s ease' }}
          onMouseEnter={(e) => e.currentTarget.style.background = '#eff5fb'}
        >
          <i className="fas fa-shield-alt" style={{ color: '#10b981', fontSize: '14px', minWidth: '16px' }}></i>
          <span style={{ color: '#666' }}>Guaranteed High-Precision Printing</span>
        </div>
        <div className="d-flex align-items-center gap-3 p-2 rounded-2" style={{ background: '#f8f9fb', transition: 'all 0.3s ease' }}
          onMouseEnter={(e) => e.currentTarget.style.background = '#eff5fb'}
        >
          <i className="fas fa-shipping-fast" style={{ color: '#10b981', fontSize: '14px', minWidth: '16px' }}></i>
          <span style={{ color: '#666' }}>Fast Delivery across Chennai</span>
        </div>
      </div>
    </div>
  );
};

export default OrderSummarySidebar;
